
import React, { Component } from 'react';

import { DetailProvider, DetailContext } from 'core/DetailProvider';
import { FormContext, FormProvider } from 'core/FormProvider';
import { YellowButton } from 'ui/Button';
import { TractorUnitForm } from './Form';
import Layout from 'components/Dashboard/Layout';


export default class TractorUnitDetail extends Component {

  onLoaded = (item) => {
    document.title = `ТС ${item.number || item.id}`;
  };

  render() {
    const { match } = this.props;
    return (
      <DetailProvider
        url={`fleet/truck/${match.params.id}`}
        onLoaded={(item) => this.onLoaded(item)}
      >
        <DetailContext.Consumer>
          {detailContext => {
            let { item } = detailContext;
            return (
              <FormProvider
                url={item.meta.url}
                postSaveMessage={'ТС обновлено'}
                postSave={(item) => detailContext.updateItem(item)}
                item={item}
              >
                <FormContext.Consumer>
                {formContext => {
                  const { loading } = formContext;
                  return (
                    <Layout>
                      <Layout.Header
                        title={'Редактирование ТС'}
                        backUrl={'/tractor_unit'}
                      />

                      <Layout.ContentSimple>
                        <TractorUnitForm />

                        <div className={'mt-30'}>
                          <YellowButton
                            onClick={(e) => formContext.handleSubmit(e)}
                            disabled={loading}
                            size={'large'}
                          >
                            Обновить ТС
                          </YellowButton>
                        </div>
                      </Layout.ContentSimple>
                    </Layout>
                  )
                }}
                </FormContext.Consumer>
              </FormProvider>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
